import React from "react";

import styled from "styled-components";

const Container = styled.div``;

const Step = props => {
  return <Container>Storage</Container>;
};

export default Step;
